export default ['category', 'product']
